import {FComponent} from "./f-component";

interface P {
    action: () => void;
    next: (value) => any;
}
interface S {
}


export class HoldRepeatingAction extends FComponent<P,S> {
    constructor(props, context) {
        super(props, context);

        this.onUnmount(() => {
            if (this.clear) {
                this.clear();
                this.clear = null;
            }
        });
    }
    clear;

    render() {
        const {action, next} = this.props;

        return next({
            start: () => {
                this.clear = startRepeater(action, 300, 100);
            },
            stop: () => {
                if (this.clear) {
                    this.clear();
                    this.clear = null;
                }
            },
        });
    }
}

const startRepeater = (action, delay1, delayInterval) => {
    action();

    let interval;
    let timeout = setTimeout(
        () => {
            timeout = null;
            action();

            interval = setInterval( action, delayInterval );
        },
        delay1,
    );


    return () => {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        if (interval) {
            clearInterval(interval);
            interval = null;
        }
    };
};
